// types
import { UserDisplayData } from "../types";

export const getUserApi = ( apiInstance: API.Client ) => async (uid: string) => {
  const userResult = await apiInstance.Entity.collection( 'user' ).get( uid );
  if ( !userResult ) return null;

  return { ...userResult, no: 0 } as UserDisplayData;
};
